<key-graph *ngIf="data"
    [datasets]="data.datasets"
    [labels]="data.labels"
    [yAxes]="data.yAxes"
    [xAxis]="data.xAxis"
    [stacked]="data.stacked"
    [legend]="data.legend"
    [averages]="data.averages"
    [showLabelsOnGraph]="data.showLabelsOnGraph"
    (onPointSelection)="onMeasureSelection.emit(data.datasets[$event.datasetIndex].id)"></key-graph>